var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.feedback)?_c('em',[_vm._v(_vm._s(_vm.feedback))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dashboard"},_vm._l((_vm.blogs),function(n){return _c('blogitem',{attrs:{"data":n}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-780739a2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/Dynamic/app/blog/confessionPages/dashboard.vue
// module id = 607
// module chunks = 0